import AdminLayout from '../../templates/AdminLayout';
import DailySignupUserList from '../../UI/organisms/etc/DailySignupUserList';

const SignupUserCountPage = () => {
  return <AdminLayout title={'일일 가입자 수'} content={<DailySignupUserList />} sideType={0} />;
};

export default SignupUserCountPage;
